// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Poppins', 'Poppins Fallback'"},"className":"__className_bc37b7","variable":"__variable_bc37b7"};